export const ASSIGNMENT_ITEM_TYPE = 'Assignment';
export const MATERIAL_ITEM_TYPE = 'Material';
export const SUBMISSION_ITEM_TYPE = 'Submission';
export const UB_CLASS_ROOM_POST_ITEM_TYPE = 'UBClassRoomPost';
export const UB_COMMENT_ITEM_TYPE = 'UBComment';
export const UB_INBOX_MESSAGE_ITEM_TYPE = 'UBInboxMessage';
export const UNKNOWN_ITEM_TYPE = 'Unknown';

export const ANNOUNCEMENTS_ITEM_TYPE = 'announcements';
export const ASSIGNMENT_LOWER_ITEM_TYPE = 'assignment';
export const COMMON_ROOM_ITEM_TYPE = 'commonRoom';
export const LTI_INTEGRATION_ITEM_TYPE = 'ltiIntegration';
export const MENU_ITEM_TYPE = 'menu';
export const MY_SPACE_PAGE_ITEM_TYPE = 'my_space_page';
export const MY_SPACE_PAGE_RECENTLY_VIEWED_SECTION_ITEM_TYPE =
  'my_space_page_recently_viewed_section';
export const MY_SPACE_PAGE_REMAINING_ITEM_TYPE = 'my_space_page_remaining';
export const MY_SPACE_PAGE_SEARCH_RESULT_ITEM_TYPE =
  'my_space_page_search_result';
export const NOTIFICATION_SETTING_ITEM_TYPE = 'notificationSetting';
export const SIS_IMPORT_ITEM_TYPE = 'sisImport';
export const SPACE_SELECTOR_ITEM_TYPE = 'spaceSelector';

export const RBAC_PERMISSIONS_ALERT_ITEM_TYPE = 'rbac_permissions_alert';
